import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import { AlterarEmail } from 'src/paginas/alterar-email'
import { AlterarEmailToken } from 'src/paginas/alterar-email-token'
import ValidacaoCertificado from 'src/paginas/validacao-certificado'

import { RotaPrivada } from '../componentes/autenticacao'
import { Layout } from '../componentes/layout'
import { LayoutMatricula } from '../componentes/layout-matricula'
import { Entrar, PrimeiroAcesso, RecuperarSenha } from '../paginas'
import { AcademicoRotas } from './academico'
import { AlunoRotas } from './aluno'
import { MatriculaRotas } from './matricula'
import { CertificacaoRotas } from './parceiroCertificacao'
import { ProfessorRotas } from './professor'
import { Redirecionador } from './redirecionador'
import { ReingressoRotas } from './reingresso'
import { RescisaoRotas } from './rescisao'
import { ResponsavelFinanceiroRotas } from './responsavel-financeiro'
import { SalaAulaRotas } from './sala-aula'
import { SistemaRotas } from './sistema'

/**
 * Carregada via React.lazy (não import direto) para isolar o bundle do
 * design-system-v2 num chunk separado das rotas autenticadas do backoffice —
 * ver docs/adr/0001-design-system-v2.md.
 */
const CondicaoEspecialPublica = React.lazy(
  () => import('../paginas/ipgs/condicao-especial/publica')
)

export enum RotasApp {
  Home = '/',
  Academico = '/academico',
  Aluno = '/aluno',
  Sistema = '/sistema',
  Matricula = '/matricula',
  SalaAula = '/sala-aula',
  Professor = '/professor',
  Entrar = '/entrar',
  RecuperarSenha = '/recuperar-senha',
  ValidacaoCertificado = '/validacao-certificado',
  PrimeiroAcesso = '/primeiro-acesso',
  ResponsavelFinanceiro = '/responsavel-financeiro',
  AlterarEmail = '/alterar-email',
  AlterarEmailToken = '/alterar-dados-usuario',
  Reingresso = '/reingresso',
  Rescisao = '/rescisao',
  Certificacao = '/certificacao',
  /**
   * Rota pública (sem RotaPrivada) — tela do aluno para aceitar uma
   * condição especial (matrícula negociada). Path mantido igual ao que
   * `link-aluno.ts` já monta hoje — ver docs/adr/0001-design-system-v2.md.
   */
  CondicaoEspecialPublica = '/condicao-especial'
}

export const Rotas: React.FC = () => {
  return (
    <Switch>
      <RotaPrivada exact path={RotasApp.Home}>
        <Redirecionador />
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Academico}>
        <Layout centralizado={true}>
          <AcademicoRotas />
        </Layout>
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Reingresso}>
        <Layout centralizado={true}>
          <ReingressoRotas />
        </Layout>
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Rescisao}>
        <Layout centralizado={true}>
          <RescisaoRotas />
        </Layout>
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Sistema}>
        <Layout centralizado={true}>
          <SistemaRotas />
        </Layout>
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Aluno}>
        <Layout centralizado={true}>
          <AlunoRotas />
        </Layout>
      </RotaPrivada>
      <RotaPrivada path={RotasApp.Professor}>
        <Layout centralizado={true}>
          <ProfessorRotas />
        </Layout>
      </RotaPrivada>
      <Route path={RotasApp.Matricula}>
        <LayoutMatricula>
          <MatriculaRotas />
        </LayoutMatricula>
      </Route>
      <RotaPrivada path={RotasApp.SalaAula}>
        <Layout centralizado={true}>
          <SalaAulaRotas />
        </Layout>
      </RotaPrivada>
      <Route path={`${RotasApp.ValidacaoCertificado}/:idMatricula`}>
        <LayoutMatricula>
          <ValidacaoCertificado />
        </LayoutMatricula>
      </Route>
      <Route path={RotasApp.Entrar}>
        <Entrar />
      </Route>
      <Route path={RotasApp.RecuperarSenha}>
        <RecuperarSenha />
      </Route>
      <Route path={RotasApp.PrimeiroAcesso}>
        <PrimeiroAcesso />
      </Route>
      <RotaPrivada path={RotasApp.ResponsavelFinanceiro}>
        <Layout centralizado={true}>
          <ResponsavelFinanceiroRotas />
        </Layout>
      </RotaPrivada>
      <Route path={RotasApp.AlterarEmail}>
        <AlterarEmail />
      </Route>
      <Route path={RotasApp.AlterarEmailToken}>
        <AlterarEmailToken />
      </Route>
      <Route path={RotasApp.Certificacao}>
        <Layout centralizado={false}>
          <CertificacaoRotas />
        </Layout>
      </Route>
      <Route path={`${RotasApp.CondicaoEspecialPublica}/:id`}>
        <React.Suspense fallback={null}>
          <CondicaoEspecialPublica />
        </React.Suspense>
      </Route>
      <Route path="*">
        <Redirect to={RotasApp.Home} />
      </Route>
    </Switch>
  )
}

export * from './academico'
export * from './sistema'
export * from './matricula'
export * from './parceiroCertificacao'
